// extracted by mini-css-extract-plugin
export default {"btn":"ViewAllButton_btn__2neR+"};